import * as React from 'react';
import { AScene } from '@eagerlogic/react-mvc';
import { AddVacationModel } from '../AddVacationModel';
import { AddVacationController } from '../AddVacationController';
import { Fab, Icon } from '@material-ui/core';
import { AddVacationDialog } from './AddVacationDialog';

export class AddVacationScene extends AScene<Props, AddVacationModel, AddVacationController> {

    protected createControlller(): AddVacationController {
        return new AddVacationController(this.props.onVacationAdded);
    }

    public render(): React.ReactNode {
        return (
            <>
                <Fab aria-label="Add" style={{ position: 'fixed', right: '36px', bottom: '36px', backgroundColor: '#e53935' }} onClick={() => {this.controller.showDialog()}}>
                    <Icon style={{ color: '#fff' }}>add</Icon>
                </Fab>

                {this.model.addVacationDialogModel != null && (
                    <AddVacationDialog model={this.model.addVacationDialogModel} controller={this.controller} />
                )}
            </>
        );
    }


}

export interface Props {
    onVacationAdded: {(): void};
}